module.exports = __webpack_public_path__ + "static/media/hamburger.3819dcba.svg";